import React from 'react';
import SamplePostCard from './SamplePostCard';

const SamplePostsSection = () => {
  const samplePosts = [
    {
      reactions: { relate: 127, correct: 89, notBest: 12 },
      timestamp: "2 hours ago"
    },
    {
      reactions: { relate: 203, correct: 156, notBest: 8 },
      timestamp: "5 hours ago"
    },
    {
      reactions: { relate: 94, correct: 67, notBest: 23 },
      timestamp: "1 day ago"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 px-4 md:px-6 lg:px-8 bg-muted/30">
      <div className="container mx-auto max-w-6xl">
        {/* Section header */}
        <div className="text-center mb-10 md:mb-14 lg:mb-16 space-y-3 md:space-y-4">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
            See How It Works
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Real posts from our community (content blurred for privacy). See how others receive support through reactions.
          </p>
        </div>

        {/* Sample posts grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {samplePosts?.map((post, index) => (
            <SamplePostCard
              key={index}
              reactions={post?.reactions}
              timestamp={post?.timestamp}
            />
          ))}
        </div>

        {/* Privacy note */}
        <div className="mt-8 md:mt-10 lg:mt-12 text-center">
          <p className="caption text-muted-foreground italic">
            All content is anonymized and blurred to protect user privacy. Join to read full stories.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SamplePostsSection;